import React, { useRef } from "react";
import { useStyles } from "./cardStyles";
import Box from "@mui/material/Box";
import { ICard } from "./ICard";
import useCardAnimations from "../../../hooks/animations/useCardAnimations";
const imageStorage = process.env.REACT_APP_GCP_STORAGE;
const Card = ({
    index,
    sku,
    eyebrow,
    description,
    background,
    attributes,
}: ICard) => {
    const backgroundImage =
        background === "material"
            ? `url(${imageStorage}/productgridbg_${index}.png)`
            : `url(${background})`;

    const { classes } = useStyles({ backgroundImage });
    const root = useRef(null);
    useCardAnimations(root, index);

    if (!attributes) {
        return null;
    }

    return (
        <Box data-name="Card" ref={root} className={classes.root}>
            <Box className={classes.imageContainer}>
                <div className={classes.imageBackground} />
                <img
                    id="watch-image"
                    src={attributes.image}
                    alt={`Watch ${attributes.name}`}
                    className={classes.image}
                />
            </Box>

            <span id="eyebrow" className={classes.eyebrow}>
                {eyebrow}
            </span>
            <span id="heading" className={classes.heading}>
                {attributes.name}
            </span>
            <span id="description" className={classes.description}>
                {description}
            </span>
        </Box>
    );
};

export default Card;
